module.exports = __webpack_public_path__ + "static/media/ic-chevron-right.855bb38b.svg";